// src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";
import Nav from "./components/Nav";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import HomePage           from "./pages/HomePage";
import PropertiesPage     from "./pages/PropertiesPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import AddPropertyPage    from "./pages/AddPropertyPage";
import DashboardPage      from "./pages/DashboardPage";
import AdminPage          from "./pages/AdminPage";
import LoginPage          from "./pages/LoginPage";
import RegisterPage       from "./pages/RegisterPage";

// Global styles
const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Sora:wght@400;600;700&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }
  body { font-family: 'Plus Jakarta Sans', sans-serif; background: #f8faf8; color: #1a2e1a; -webkit-font-smoothing: antialiased; }
  input, select, textarea, button { font-family: inherit; }
  input:focus, select:focus, textarea:focus { outline: 2px solid #1a6b3c; outline-offset: 1px; }
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: #f0f4f0; }
  ::-webkit-scrollbar-thumb { background: #1a6b3c; border-radius: 3px; }
  a { color: inherit; }
  img { max-width: 100%; display: block; }
`;

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <style>{globalCSS}</style>
        <Toaster
          position="top-center"
          toastOptions={{
            style: { fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 14 },
            success: { iconTheme: { primary: "#1a6b3c", secondary: "white" } },
          }}
        />
        <Nav />
        <Routes>
          <Route path="/"             element={<HomePage />} />
          <Route path="/properties"   element={<PropertiesPage />} />
          <Route path="/property/:id" element={<PropertyDetailPage />} />
          <Route path="/login"        element={<LoginPage />} />
          <Route path="/register"     element={<RegisterPage />} />

          {/* Protected routes — require login */}
          <Route path="/add-property" element={
            <ProtectedRoute><AddPropertyPage /></ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute><DashboardPage /></ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute><AdminPage /></ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
